import { Dock, PageScroll } from "@Components/Page";
import { WorkflowTree } from "@Components/Workflows/Components/WorkflowTree";
import { WorkflowWrapper } from "@Components/Workflows/Components/WorkflowWrapper";
import { useConnectionTree } from "@Hooks/connections/useTreeData";
import { useUserContext } from "@Hooks/contexts/useUserContext";
import { Banner, Button, CheckIcon, PageTitle, StructureIcon } from "@UI";
import { insertImage } from "@Utils/doc/insertImage";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
export function StructureImport({ onExit }) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = React.useState(false);
    const [result, setResult] = React.useState(null);
    const token = useUserContext((s)=>s?.user?.meta?.access_token.token);
    const tree = useConnectionTree({
        token,
        type: "workspaces"
    });
    const onRunWorkflow = useCallback(async ()=>{
        if (!token) return;
        setIsLoading(true);
        setResult(null);
        try {
            await insertImage({
                id: tree.selectedId,
                token
            });
            setResult({
                id: tree.selectedId,
                status: "done"
            });
        } catch (error) {
            console.error("Structure import failed:", error);
            setResult({
                id: tree.selectedId,
                status: "error"
            });
        } finally{
            setIsLoading(false);
        }
    }, [
        token,
        tree.selectedId
    ]);
    const status = result?.id === tree.selectedId ? result.status : null;
    return /*#__PURE__*/ React.createElement(WorkflowWrapper, {
        onBack: onExit
    }, /*#__PURE__*/ React.createElement(PageScroll, null, /*#__PURE__*/ React.createElement(PageTitle, {
        title: t("workflows.StructureImport.title"),
        lede: t("workflows.StructureImport.lede")
    }), /*#__PURE__*/ React.createElement(WorkflowTree, {
        tree: tree,
        label: t("workflows.StructureImport.title"),
        searchPlaceholder: t("workflows.StructureImport.search"),
        emptyIcon: StructureIcon,
        emptyTitle: t("workflows.StructureImport.noItemsTitle"),
        emptyText: t("workflows.StructureImport.noItemsMessage")
    })), !tree.showNoItemsMessage && !tree.hasError && /*#__PURE__*/ React.createElement(Dock, null, status === "error" && /*#__PURE__*/ React.createElement(Banner, {
        tone: "error"
    }, t("workflows.StructureImport.failed")), status === "done" && /*#__PURE__*/ React.createElement(Banner, {
        icon: /*#__PURE__*/ React.createElement(CheckIcon, null)
    }, t("workflows.StructureImport.done")), /*#__PURE__*/ React.createElement(Button, {
        size: "lg",
        disabled: !tree.selectedItem,
        loading: isLoading,
        onClick: onRunWorkflow
    }, t("workflows.StructureImport.insert"))));
}
